import { render, staticRenderFns } from "./UploadJsonFile.vue?vue&type=template&id=97ec2a2c&"
import script from "./UploadJsonFile.vue?vue&type=script&lang=js&"
export * from "./UploadJsonFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadJsonFile.vue?vue&type=style&index=0&id=97ec2a2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports